import { createRequestDataSource } from "@ngneat/elf-requests";
import { selectAllEntities } from "@ngneat/elf-entities";
import { bannersStore } from "@store/banners/banners.store";

export const getBannersDataSource = createRequestDataSource({
  store: bannersStore,
  data$: () => bannersStore.pipe(selectAllEntities()),
  requestKey: "getBanners",
  dataKey: "banners",
});